const data = {
  counterText: 'Seulement quelques places disponibles',
  loading: 'Charger',
  next: 'Continuer',
  previous: 'Antérieur',
  smCounterText: 'Places limitées !',
};

export default data;
